/**
 * The arrange-mode context, split from the components that use it.
 *
 * Same split as `fireworksContext.ts` and for the same reason: a module that exports both a
 * component and a hook defeats fast refresh, and oxlint says so with warnings-as-errors.
 */

import { createContext, useContext } from "react";

export type EditMode = {
  editing: boolean;
  toggle: () => void;
};

export const EditModeContext = createContext<EditMode | null>(null);

export function useEditMode(): EditMode {
  const value = useContext(EditModeContext);
  if (!value) throw new Error("useEditMode outside EditModeProvider");
  return value;
}
